<template>
  <div class="modal" v-if="seen">
    <div class="upload_browse_folder">
      <div class="" style="padding: 1.2em">
        <div class="d-flex justify-content-between align-items-center">
          <h4>{{ title }}</h4>
          <span @click="close" class="close_advanced_search">
            <img src="@/assets/search-icons/Close.svg" />
          </span>
        </div>
        <div class="input">
          <label>
            {{ label }}
          </label>
          <input
            type="text"
            v-model="filename"
            ref="file"
            id="file"
            :placeholder="placeholder"
            autocomplete="false"
            @keypress="enterKey"
          />
          <span class="error" v-if="specialChar_error">{{
            specialChar_error
          }}</span>
          <span class="error" v-if="exist">*File already exist</span>
          <span class="error" v-if="error">*Required</span>
        </div>
        <div class="browse_folder_nav" v-if="current_index.length">
          <browse-folder-breadcrumb
            :path="current_index"
            @browse_dir="browse_dir"
          ></browse-folder-breadcrumb>
        </div>
        <!-- <div class="browse_folders">
              <ul class="selected_folders" v-if="folders.length">
                <li v-for="(name, index) in folders" :key="index" :class="{'highlighted': name.highlighted}">
                  <span @click="highlight(index)">
                    <template v-if="name.group == 'PUBLIC'">
                      <img src="@/assets/icons/folder/Public.svg" height="32px" width="32px" />
                    </template>
                    <template v-if="name.group == 'GROUP'">
                      <img src="@/assets/icons/folder/Group.svg" height="32px" width="32px" />
                    </template>
                    <template v-if="name.group == 'PROJECT'">
                      <img src="@/assets/icons/folder/Project.svg" height="32px" width="32px" />
                    </template>
                    <template v-if="name.group == 'PERSONAL'">
                      <img src="@/assets/icons/folder/General.svg" height="32px" width="32px" />
                    </template>
                    &nbsp;&nbsp;
                    <span class="dir">
                      {{ name.dir }}
                    </span>
                  </span>
                  <span v-if="name.hasChild" @click="browse(index)">
                    <svg style="width:14px;height:14px" viewBox="0 0 18 18">
                      <path fill="#333" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                    </svg>
                  </span>
                </li>
              </ul>
            </div> -->
      </div>
      <div class="buttons d-flex justify-content-center align-items-center">
        <span class="upload_file" @click="send">
          <img src="@/assets/add-new-white.svg" /> &nbsp;&nbsp;
          <span>{{ button_text }}</span>
        </span>
      </div>
    </div>
    <!-- <div class="box">
            <span class="close-box" @click="close">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="#000000" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                </svg>
            </span>
            <div class="btn">
                <button type="button" @click="send">Create</button>
                <span class="loader" v-if="loader">
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" width="40px" height="40px" class="lds-dual-ring" style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;"><circle cx="50" cy="50" fill="none" stroke-linecap="round" stroke="#039aed" r="30" stroke-dasharray="41.41592653589793 41.41592653589793" stroke-width="8"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>
                    Please wait...
                </span>
            </div>
        </div> -->
  </div>
</template>
<style scoped>
.highlighted {
  background: #d9ecfa !important;
  padding-left: 8px !important;
}
.browse_folder_nav {
  margin: 15px 0;
}
.input {
  display: flex;
  flex-direction: column;
  justify-content: left;
}
.input label {
  font-size: 14px;
  color: #4b5458;
  text-align: left;
}
.input input {
  border: 1px solid #a7b9cb;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 10px 12px;
  margin: 0 0 10px;
}

.input .error {
  text-align: left;
  color: #fc6d6c;
  font-size: 14px;
}
.buttons {
  background: #ffffff;
  box-shadow: 0px -4px 40px rgba(0, 0, 0, 0.06);
  padding: 1.3em 1.2em;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.selected_folders {
  height: 320px;
  overflow-y: auto;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.selected_folders li {
  padding-left: 0;
}
h4 {
  font-size: 18px;
  font-weight: bold;
}
.browse_folder_nav {
  text-align: left;
}
.close_advanced_search {
  background: #f2f7fc;
  display: inline-flex;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.create_new_folder {
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  width: 132px;
  height: 42px;
  color: #3f96d1;
  border: 1px solid #3f96d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.upload_file {
  background: #3f96d1;
  cursor: pointer;
  border-radius: 9px;
  width: 182px;
  height: 42px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.btn-save {
  background: transparent;
  cursor: pointer;
  border-radius: 5px;
  color: #3f96d1;
  border: 1px solid #3f96d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  padding: 0.4em 0.6em;
  height: 40px;
}

.folder-name {
  border-radius: 8px;
  border: 1px solid #a7b9cb;
  padding: 0.6em 0.6em;
  width: 100%;
  flex-basis: auto;
}
.action-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1em;
}
.btn-cancel {
  background: #fc6d6c;
  cursor: pointer;
  border-radius: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  padding: 0.4em 0.6em;
  height: 40px;
}
.upload_browse_folder {
  background: #fff;
  border-radius: 8px;
  width: 460px;
}
.modal {
  display: flex;
}
.cgn {
  display: flex;
  flex-direction: column;
}
.cgn span {
  margin-bottom: 0.4em;
}
</style>
<script>
import { mapMutations } from "vuex";
import cookies from "@/services/cookies";
import { camelCase } from "lodash";
import BrowseFolderBreadcrumb from "@/components/Browse-Folder-Breadcrumb";

export default {
  components: {
    BrowseFolderBreadcrumb,
  },
  data() {
    return {
      seen: false,
      type: "",
      title: "",
      filename: "",
      error: false,
      loader: false,
      specialChar_error: "",
      exist: false,
      names: [],
      current_index: [],
      current_name: "My Space",
      selected_index: null,
      selected_files: [],
      placeholder: "",
      label: "",
      button_text: "",
      current_directory_id: "",
      dir: null,
    };
  },
  computed: {
    folders: function () {
      let that = this;
      return this.names.filter(function (name) {
        return !that.selected_files.includes(name.id);
      });
    },
  },
  methods: {
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "UPDATE_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SORT_DIRECTORY_CHILDREN",
      "UPDATE_TOTAL_USED_SPACE",
    ]),
    genId(name) {
      return camelCase(name);
    },
    specialChar(str) {
      let specialChars = '<>*?:|"\\/';
      let found = "";
      for (let i = 0; i < specialChars.length; i++) {
        if (str.indexOf(specialChars[i]) > -1) {
          found += specialChars[i];
        }
      }
      return found;
    },
    addusertofolder(folder_id, folder_name, await_status) {
      this.$parent.addusertofolder(folder_id, folder_name, await_status);
    },
    browse_dir(dir) {
      let that = this;

      let data = {
        token: cookies.getCookie("token"),
        id: dir[1],
      };

      this.$socket.emit("browsemovetofolder", data, function (data) {
        if (data.data === true) {
          that.names = data.directory;
          that.current_index.pop();
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    highlight(index) {
      console.log(this.names[index]);
      this.dir = this.names[index];
      this.current_directory_id = this.names[index].id;
      this.names = this.names.map((name) => {
        name.highlighted = false;
        return name;
      });
      this.names[index].highlighted = true;
    },
    back() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("browsemovetofolder", data, function (data) {
        if (data.data === true) {
          that.names = data.directory;
          that.current_index = [];
        }

        if (data.data === false) {
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    load(type) {
      let that = this;
      if (type == "word") {
        this.title = "Create Word Document";
        this.placeholder = "Enter file name";
        this.label = "File Name";
        this.button_text = "Create New File";
      }

      if (type == "sheets") {
        this.title = "Create Sheet Document";
        this.placeholder = "Enter file name";
        this.label = "File Name";
        this.button_text = "Create New File";
      }

      if (type == "powerpoint") {
        this.title = "Create Presentation Document";
        this.placeholder = "Enter file name";
        this.label = "File Name";
        this.button_text = "Create New File";
      }

      if (type == "folder") {
        this.title = "Create New Folder";
        this.placeholder = "Enter folder name";
        this.label = "Folder Name";
        this.button_text = this.title;
      }

      if (type == "group-folder") {
        this.title = "Create New Group Folder";
        this.placeholder = "Enter group folder name";
        this.label = "Folder Name";
        this.button_text = "Create New Folder";
      }

      this.names = [];
      this.current_index = [];
      this.current_name = "My Space";
      // this.index = index
      // this.type = type
      this.selected_index = null;
      this.selected_files = [];
      this.error = "";
      this.filename = "";
      this.specialChar_error = "";
      this.type = type;
      this.loader = false;
      this.seen = true;
      this.exist = false;

      // this.$refs.file.focus()

      let data = {
        token: cookies.getCookie("token"),
      };

      this.$socket.emit("browsemovetofolder", data, function (data) {
        if (data.data === true) {
          that.names = data.directory;
        }

        if (data.data === false) {
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });

      this.$nextTick(() => this.$refs.file.focus());
    },
    browse(index) {
      this.error = false;
      let that = this;
      let id = this.names[index].id;
      let is_public = this.names[index].is_public;
      let is_group = this.names[index].is_group;
      let db = this.names[index].db;
      let parent_id = this.names[index].parent_id;
      let name = this.names[index].dir;
      let is_default = this.names[index].is_default === true;

      let data = {
        token: cookies.getCookie("token"),
        id: this.names[index].id,
      };

      that.names = [];

      this.$socket.emit("browsemovetofolder", data, function (data) {
        if (data.data === true) {
          that.names = data.directory;
          that.current_index.push({
            id: id,
            db: db,
            is_public: is_public,
            is_group: is_group,
            parent_id: parent_id,
            name: name,
            is_default: is_default,
          });

          that.current_name = name;
        }

        if (data.data === false) {
          that.seen = false;
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    create(evt) {
      // if (evt.keyCode != 13) {
      //   console.log('pppip')
      //   return
      // }

      this.specialChar_error = false;
      this.error = false;

      if (this.specialChar(this.filename)) {
        this.specialChar_error =
          this.specialChar(this.filename) + " are not allowed";
        return;
      }

      if (this.filename == "") {
        this.error = true;
        return;
      }

      this.loader = true;

      if (this.type == "word") {
        let docName = this.filename;
        let data = {
          token: cookies.getCookie("token"),
          docname: this.filename,
          db: localStorage.getItem("db"),
          current_directory_id: localStorage.getItem("current_directory_id"),
        };

        let that = this;

        this.$socket.emit("create-doc", data, async function (data) {
          if (data.data === true) {
            if (data.found === 1) {
              that.loader = false;
              that.exist = true;
            } else {
              that.loader = false;
              that.seen = false;
              await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
              await that.SORT_DIRECTORY_CHILDREN();
              let total_used_space =
                data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
              that.UPDATE_TOTAL_USED_SPACE(total_used_space);
              let elem = document.querySelector("#" + that.genId(docName));
              elem.scrollIntoView();
              elem.classList.add("highlighted");
            }
          }

          if (data.data === false) {
            that.seen = false;
            that.$parent.logincall();
            that.$router.push('/login')
          }
        });
      }

      if (this.type == "sheets") {
        let docName = this.filename;
        let data = {
          token: cookies.getCookie("token"),
          docname: this.filename,
          db: localStorage.getItem("db"),
          current_directory_id: localStorage.getItem("current_directory_id"),
        };

        let that = this;

        this.$socket.emit("create-excel", data, async function (data) {
          if (data.data === true) {
            if (data.found === 1) {
              that.loader = false;
              that.exist = true;
            } else {
              that.loader = false;
              that.seen = false;
              await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
              await that.SORT_DIRECTORY_CHILDREN();
              let total_used_space =
                data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
              that.UPDATE_TOTAL_USED_SPACE(total_used_space);
              let elem = document.querySelector("#" + that.genId(docName));
              elem.scrollIntoView();
              elem.classList.add("highlighted");
            }
          }

          if (data.data === false) {
            that.seen = false;
            that.$parent.logincall();
            that.$router.push('/login')
          }
        });
      }

      if (this.type == "powerpoint") {
        let docName = this.filename;
        let data = {
          token: cookies.getCookie("token"),
          docname: this.filename,
          db: localStorage.getItem("db"),
          current_directory_id: localStorage.getItem("current_directory_id"),
        };

        let that = this;

        this.$socket.emit("create-ppt", data, async function (data) {
          if (data.data === true) {
            if (data.found === 1) {
              that.loader = false;
              that.exist = true;
            } else {
              that.loader = false;
              that.seen = false;
              await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
              await that.SORT_DIRECTORY_CHILDREN();
              let total_used_space =
                data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
              that.UPDATE_TOTAL_USED_SPACE(total_used_space);
              let elem = document.querySelector("#" + that.genId(docName));
              elem.scrollIntoView();
              elem.classList.add("highlighted");
            }
          }

          if (data.data === false) {
            that.seen = false;
            that.$parent.logincall();
            that.$router.push('/login')
          }
        });
      }

      if (this.type == "folder") {
        let docName = this.filename;
        let data = {
          token: cookies.getCookie("token"),
          docname: this.filename,
          db: localStorage.getItem("db"),
          current_directory_id: localStorage.getItem("current_directory_id"),
        };

        let that = this;

        this.$socket.emit("create-folder", data, async function (data) {
          if (data.data === true) {
            if (data.found === 1) {
              that.loader = false;
              that.exist = true;
            } else {
              that.loader = false;
              that.seen = false;
              await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
              await that.SORT_DIRECTORY_CHILDREN();
              let total_used_space =
                data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
              that.UPDATE_TOTAL_USED_SPACE(total_used_space);
              let elem = document.querySelector("#" + that.genId(docName));
              elem.scrollIntoView();
              elem.classList.add("highlighted");
            }
          }

          if (data.data === false) {
            that.seen = false;
            that.$parent.logincall();
            that.$router.push('/login')
          }
        });
      }

      if (this.type == "group-folder") {
        let docName = this.filename;
        let data = {
          token: cookies.getCookie("token"),
          docname: this.filename,
          current_directory_id: localStorage.getItem("current_directory_id"),
        };

        let that = this;

        if (this.$store.getters.ISADMIN) {
          this.$socket.emit("create-group-folder", data, async function (data) {
            if (data.data === true) {
              if (data.found === 1) {
                that.loader = false;
                that.exist = true;
              } else {
                that.addusertofolder(
                  data.folder_id,
                  data.folder_name,
                  data.await
                );
                that.loader = false;
                that.seen = false;
                await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                await that.SORT_DIRECTORY_CHILDREN();
                let total_used_space =
                  data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                let elem = document.querySelector("#" + that.genId(docName));
                elem.scrollIntoView();
                elem.classList.add("highlighted");
              }
            }

            if (data.data === false) {
              that.seen = false;
              that.$parent.logincall();
              that.$router.push('/login')
            }
          });
        } else {
          this.$socket.emit(
            "create-group-folder-approval",
            data,
            async function (data) {
              if (data.data === true) {
                if (data.found === 1) {
                  that.loader = false;
                  that.exist = true;
                } else {
                  that.addusertofolder(
                    data.folder_id,
                    data.folder_name,
                    data.await
                  );
                  that.loader = false;
                  that.seen = false;
                  await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                  await that.SORT_DIRECTORY_CHILDREN();
                  let total_used_space =
                    data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                  that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                  let elem = document.querySelector("#" + that.genId(docName));
                  elem.scrollIntoView();
                  elem.classList.add("highlighted");
                }
              }

              if (data.data === false) {
                that.seen = false;
                that.$parent.logincall();
                that.$router.push('/login')
              }
            }
          );
        }
      }
    },
    enterKey(evt) {
      if(evt.keyCode == 13) {
        this.error = false;
        this.specialChar_error = "";

        if (this.filename === "") {
          this.error = true;
        } else {
          if (this.specialChar(this.filename)) {
            this.specialChar_error =
              this.specialChar(this.filename) + " are not allowed";
            return;
          }

          this.loader = true;

          if (this.type == "word") {
            let docName = this.filename;
            let data = {
              token: cookies.getCookie("token"),
              docname: this.filename,
              db: localStorage.getItem("db"),
              current_directory_id: localStorage.getItem("current_directory_id"),
            };

            let that = this;

            this.$socket.emit("create-doc", data, async function (data) {
              if (data.data === true) {
                if (data.found === 1) {
                  that.loader = false;
                  that.exist = true;
                } else {
                  that.loader = false;
                  that.seen = false;

                  await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                  await that.SORT_DIRECTORY_CHILDREN();

                  let total_used_space =
                    data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                  that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                  let elem = document.querySelector("#" + that.genId(docName));
                  elem.scrollIntoView();
                  elem.classList.add("highlighted");
                }
              }

              if (data.data === false) {
                that.seen = false;
                that.$parent.logincall();
                that.$router.push('/login')
              }
            });
          }

          if (this.type == "sheets") {
            let docName = this.filename;
            let data = {
              token: cookies.getCookie("token"),
              docname: this.filename,
              db: localStorage.getItem("db"),
              current_directory_id: localStorage.getItem("current_directory_id"),
            };

            let that = this;

            this.$socket.emit("create-excel", data, async function (data) {
              if (data.data === true) {
                if (data.found === 1) {
                  that.loader = false;
                  that.exist = true;
                } else {
                  that.loader = false;
                  that.seen = false;

                  await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                  await that.SORT_DIRECTORY_CHILDREN();

                  let total_used_space =
                    data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                  that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                  let elem = document.querySelector("#" + that.genId(docName));
                  elem.scrollIntoView();
                  elem.classList.add("highlighted");
                }
              }

              if (data.data === false) {
                that.seen = false;
                that.$parent.logincall();
                that.$router.push('/login')
              }
            });
          }

          if (this.type == "powerpoint") {
            let docName = this.filename;
            let data = {
              token: cookies.getCookie("token"),
              docname: this.filename,
              db: localStorage.getItem("db"),
              current_directory_id: localStorage.getItem("current_directory_id"),
            };

            let that = this;

            this.$socket.emit("create-ppt", data, async function (data) {
              if (data.data === true) {
                if (data.found === 1) {
                  that.loader = false;
                  that.exist = true;
                } else {
                  that.loader = false;
                  that.seen = false;

                  await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                  await that.SORT_DIRECTORY_CHILDREN();

                  let total_used_space =
                    data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                  that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                  let elem = document.querySelector("#" + that.genId(docName));
                  elem.scrollIntoView();
                  elem.classList.add("highlighted");
                }
              }

              if (data.data === false) {
                that.seen = false;
                that.$parent.logincall();
                that.$router.push('/login')
              }
            });
          }

          if (this.type == "folder") {
            let docName = this.filename;
            let data = {
              token: cookies.getCookie("token"),
              docname: this.filename,
              db: localStorage.getItem("db"),
              current_directory_id: localStorage.getItem("current_directory_id"),
            };

            let that = this;

            this.$socket.emit("create-folder", data, async function (data) {
              if (data.data === true) {
                if (data.found === 1) {
                  that.loader = false;
                  that.exist = true;
                } else {
                  that.loader = false;
                  that.seen = false;

                  await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                  await that.SORT_DIRECTORY_CHILDREN();

                  let total_used_space =
                    data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                  that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                  let elem = document.querySelector("#" + that.genId(docName));
                  elem.scrollIntoView();
                  elem.classList.add("highlighted");
                }
              }

              if (data.data === false) {
                that.seen = false;
                that.$parent.logincall();
                that.$router.push('/login')
              }
            });
          }

          if (this.type == "group-folder") {
            let docName = this.filename;
            let data = {
              token: cookies.getCookie("token"),
              docname: this.filename,
              current_directory_id: localStorage.getItem("current_directory_id"),
            };

            let that = this;

            if (this.$store.getters.ISADMIN) {
              this.$socket.emit(
                "create-group-folder",
                data,
                async function (data) {
                  if (data.data === true) {
                    if (data.found === 1) {
                      that.loader = false;
                      that.exist = true;
                    } else {
                      that.addusertofolder(
                        data.folder_id,
                        data.folder_name,
                        data.await
                      );
                      that.loader = false;
                      that.seen = false;

                      await that.UPDATE_DIRECTORY_CHILDREN(
                        data.directory_children
                      );
                      await that.SORT_DIRECTORY_CHILDREN();

                      let total_used_space =
                        data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                      that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                      let elem = document.querySelector(
                        "#" + that.genId(docName)
                      );
                      elem.scrollIntoView();
                      elem.classList.add("highlighted");
                    }
                  }

                  if (data.data === false) {
                    that.seen = false;
                    that.$parent.logincall();
                    that.$router.push('/login')
                  }
                }
              );
            } else {
              this.$socket.emit(
                "create-group-folder-approval",
                data,
                async function (data) {
                  if (data.data === true) {
                    if (data.found === 1) {
                      that.loader = false;
                      that.exist = true;
                    } else {
                      that.addusertofolder(
                        data.folder_id,
                        data.folder_name,
                        data.await
                      );
                      that.loader = false;
                      that.seen = false;

                      await that.UPDATE_DIRECTORY_CHILDREN(
                        data.directory_children
                      );
                      await that.SORT_DIRECTORY_CHILDREN();

                      let total_used_space =
                        data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                      that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                      let elem = document.querySelector(
                        "#" + that.genId(docName)
                      );
                      elem.scrollIntoView();
                      elem.classList.add("highlighted");
                    }
                  }

                  if (data.data === false) {
                    that.seen = false;
                    that.$parent.logincall();
                    that.$router.push('/login')
                  }
                }
              );
            }
          }
        }
      }
    },
    send($event) {
      this.error = false;
      this.specialChar_error = "";

      if (this.filename === "") {
        this.error = true;
      } else {
        if (this.specialChar(this.filename)) {
          this.specialChar_error =
            this.specialChar(this.filename) + " are not allowed";
          return;
        }

        this.loader = true;

        if (this.type == "word") {
          let docName = this.filename;
          let data = {
            token: cookies.getCookie("token"),
            docname: this.filename,
            db: localStorage.getItem("db"),
            current_directory_id: localStorage.getItem("current_directory_id"),
          };

          let that = this;

          this.$socket.emit("create-doc", data, async function (data) {
            if (data.data === true) {
              if (data.found === 1) {
                that.loader = false;
                that.exist = true;
              } else {
                that.loader = false;
                that.seen = false;

                await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                await that.SORT_DIRECTORY_CHILDREN();

                let total_used_space =
                  data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                let elem = document.querySelector("#" + that.genId(docName));
                elem.scrollIntoView();
                elem.classList.add("highlighted");
              }
            }

            if (data.data === false) {
              that.seen = false;
              that.$parent.logincall();
              that.$router.push('/login')
            }
          });
        }

        if (this.type == "sheets") {
          let docName = this.filename;
          let data = {
            token: cookies.getCookie("token"),
            docname: this.filename,
            db: localStorage.getItem("db"),
            current_directory_id: localStorage.getItem("current_directory_id"),
          };

          let that = this;

          this.$socket.emit("create-excel", data, async function (data) {
            if (data.data === true) {
              if (data.found === 1) {
                that.loader = false;
                that.exist = true;
              } else {
                that.loader = false;
                that.seen = false;

                await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                await that.SORT_DIRECTORY_CHILDREN();

                let total_used_space =
                  data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                let elem = document.querySelector("#" + that.genId(docName));
                elem.scrollIntoView();
                elem.classList.add("highlighted");
              }
            }

            if (data.data === false) {
              that.seen = false;
              that.$parent.logincall();
              that.$router.push('/login')
            }
          });
        }

        if (this.type == "powerpoint") {
          let docName = this.filename;
          let data = {
            token: cookies.getCookie("token"),
            docname: this.filename,
            db: localStorage.getItem("db"),
            current_directory_id: localStorage.getItem("current_directory_id"),
          };

          let that = this;

          this.$socket.emit("create-ppt", data, async function (data) {
            if (data.data === true) {
              if (data.found === 1) {
                that.loader = false;
                that.exist = true;
              } else {
                that.loader = false;
                that.seen = false;

                await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                await that.SORT_DIRECTORY_CHILDREN();

                let total_used_space =
                  data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                let elem = document.querySelector("#" + that.genId(docName));
                elem.scrollIntoView();
                elem.classList.add("highlighted");
              }
            }

            if (data.data === false) {
              that.seen = false;
              that.$parent.logincall();
              that.$router.push('/login')
            }
          });
        }

        if (this.type == "folder") {
          let docName = this.filename;
          let data = {
            token: cookies.getCookie("token"),
            docname: this.filename,
            db: localStorage.getItem("db"),
            current_directory_id: localStorage.getItem("current_directory_id"),
          };

          let that = this;

          this.$socket.emit("create-folder", data, async function (data) {
            if (data.data === true) {
              if (data.found === 1) {
                that.loader = false;
                that.exist = true;
              } else {
                that.loader = false;
                that.seen = false;

                await that.UPDATE_DIRECTORY_CHILDREN(data.directory_children);
                await that.SORT_DIRECTORY_CHILDREN();

                let total_used_space =
                  data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                let elem = document.querySelector("#" + that.genId(docName));
                elem.scrollIntoView();
                elem.classList.add("highlighted");
              }
            }

            if (data.data === false) {
              that.seen = false;
              that.$parent.logincall();
              that.$router.push('/login')
            }
          });
        }

        if (this.type == "group-folder") {
          let docName = this.filename;
          let data = {
            token: cookies.getCookie("token"),
            docname: this.filename,
            current_directory_id: localStorage.getItem("current_directory_id"),
          };

          let that = this;

          if (this.$store.getters.ISADMIN) {
            this.$socket.emit(
              "create-group-folder",
              data,
              async function (data) {
                if (data.data === true) {
                  if (data.found === 1) {
                    that.loader = false;
                    that.exist = true;
                  } else {
                    that.addusertofolder(
                      data.folder_id,
                      data.folder_name,
                      data.await
                    );
                    that.loader = false;
                    that.seen = false;

                    await that.UPDATE_DIRECTORY_CHILDREN(
                      data.directory_children
                    );
                    await that.SORT_DIRECTORY_CHILDREN();

                    let total_used_space =
                      data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                    that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                    let elem = document.querySelector(
                      "#" + that.genId(docName)
                    );
                    elem.scrollIntoView();
                    elem.classList.add("highlighted");
                  }
                }

                if (data.data === false) {
                  that.seen = false;
                  that.$parent.logincall();
                  that.$router.push('/login')
                }
              }
            );
          } else {
            this.$socket.emit(
              "create-group-folder-approval",
              data,
              async function (data) {
                if (data.data === true) {
                  if (data.found === 1) {
                    that.loader = false;
                    that.exist = true;
                  } else {
                    that.addusertofolder(
                      data.folder_id,
                      data.folder_name,
                      data.await
                    );
                    that.loader = false;
                    that.seen = false;

                    await that.UPDATE_DIRECTORY_CHILDREN(
                      data.directory_children
                    );
                    await that.SORT_DIRECTORY_CHILDREN();

                    let total_used_space =
                      data.file_size + that.$store.getters.GET_TOTAL_USED_SPACE;
                    that.UPDATE_TOTAL_USED_SPACE(total_used_space);
                    let elem = document.querySelector(
                      "#" + that.genId(docName)
                    );
                    elem.scrollIntoView();
                    elem.classList.add("highlighted");
                  }
                }

                if (data.data === false) {
                  that.seen = false;
                  that.$parent.logincall();
                  that.$router.push('/login')
                }
              }
            );
          }
        }
      }
    },
    close() {
      this.error = "";
      this.filename = "";
      this.specialChar_error = "";
      this.seen = false;
      this.loader = false;
    },
  },
  mounted() {
    this.current_directory_id = localStorage.getItem("current_directory_id");
  },
};
</script>
